import { render, staticRenderFns } from "./InventoryStatusBadge.vue?vue&type=template&id=b365a374"
import script from "./InventoryStatusBadge.vue?vue&type=script&lang=js"
export * from "./InventoryStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports